module.exports = __webpack_public_path__ + "static/media/img_join5.f50d1081.png";